import { EstimateMode } from "src/store/reducers/tradeIn";
import React from "react";
import MuiButton from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";

export const TradePendingEstimateToggle = ({
    onClick,
    estimateInputMode,
}: {
    onClick: () => void;
    estimateInputMode: EstimateMode;
}) => {
    const { t } = useTranslation();

    return (
        <div
            className="TradePending__header--container TradePendingCustomerEstimate"
            id="TradePendingGroup"
            data-e2e="tradePendingSection"
        >
            <MuiButton className="TradePending__body--conditionalCopyEstimate" onClick={onClick}>
                {estimateInputMode === EstimateMode.TradePending
                    ? t("TradePending.estimate")
                    : t("TradePending.goBack")}{" "}
            </MuiButton>
        </div>
    );
};
